import {MARKETING_PREFERENCES_CHANNELS, MARKETING_PREFERENCES_PRODUCTS} from "Setup/config";

export const firstNameRegEx = /^[ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõöøùúûüýþÿŒœŠŽšžŸµƒªº¡¿A-Za-z\s-`'']+$/;
export const lastNameRegEx = /^[ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõöøùúûüýþÿŒœŠŽšžŸµƒªº¡¿A-Za-z\s-`'']+$/;
export const telephoneNumberRegEx = "^[+][\\\\\\d\\s]*$|^[\\\\\\d\\s]*$|^[0-9]+[-]{1}[0-9]*$";
export const emailRegEx = "\\b[A-Za-z0-9._%+-]+@((?!\\.\\.)[A-Za-z0-9.-])+\\.[A-Za-z]{2,4}\\b$";

export const loginUsernameRequirements = [];

export const usernameRequirements = [
    {label: "Must not contain symbols or spaces", rule: new RegExp(/^(?:(?![-!$%^&£*@#()_+|~=`{}¬¦\[\]:";'<>?,.\/\\ \t\r\n\f]).)*$/)},
    {label: "Must be 2-50 characters long", rule: new RegExp(/^.{2,50}$/)},
    {label: "Must begin with a letter", rule: new RegExp(/^[a-zA-Z]/)},
];

export const passwordRequirements = [
    {label: "Must not contain spaces", rule: new RegExp(/^\S*$/)},
    {label: "Must be at least 8 characters long", rule: new RegExp(/^.{8,}$/)},
    {label: "Must contain at least one uppercase character", rule: new RegExp(/([A-Z])/)},
    {label: "Must contain at least one lowercase character", rule: new RegExp(/([a-z])/)},
    {label: "Must contain at least one number", rule: new RegExp(/\d/)},
];

export const marketingProductOptions = MARKETING_PREFERENCES_PRODUCTS.map(item => {
    const [key, value] = Object.entries(item)[0];
    return {
        name: key,
        label: value.label
    };
})

export const marketingChannelOptions = MARKETING_PREFERENCES_CHANNELS.map(channel => {
    return {name: `${channel}`, label: channel}
})
